L.TextBlock = L.Class.extend({
  options: {
    width: 100,
    height: 50,
    position: {
      x: 0,
      y: 0
    },
    html: '<h4>Text Block</h4><p>Description here...</p>'
  },

  initialize: function (options) {
    L.Util.setOptions(this, options);
  },

  addTo: function(map) {
    this._mainMap = map;
    var size = this._mainMap.getSize();

    if (!this.options.viewport) {
      this.options.viewport = { // default viewport to map dimensions if not set
        height: size.y,
        width: size.x
      };
    }

    if (!this.options.container) {
      this.options.container = this._mainMap._controlContainer;
    }

    // Creating the container and stopping events from spilling through to the main map.
    this._container = L.DomUtil.create('div', 'leaflet-text-block-container', this.options.container);
    this._container.style.width = this.options.width + 'px';
    this._container.style.height = this.options.height + 'px';
    this._container.style.display = 'block';
    this._container.className += ' unselectable';

    this._textBlock = L.DomUtil.create('div', 'leaflet-text-block');
    this._textBlock.innerHTML = this.options.html;

    this._textBlock.style.width = this.options.width + 'px';
    this._textBlock.style.height = this.options.height + 'px';
    this._textBlock.enableResizeDown = false;
    this._textBlock.style.display = 'block';
    this._textBlock.originalW = this.options.width;
    this._textBlock.originalH = this.options.height;

    this._container.appendChild(this._textBlock);

    this._setPosition(this.options.position);

    L.DomEvent.disableClickPropagation(this._container);
    L.DomEvent.on(this._container, 'mousewheel', L.DomEvent.stopPropagation);
    this._textBlock.style.resize = 'none';

    this._initInteraction();
    this._mainMap.on("resize", this._onMainMapResize, this);

    return this._container;
  },

  remove: function() {
        if (this._mainMap) {
            this._mainMap.off("resize", this._onMainMapResize, this);

            if (this._container.parentNode) {
                this._container.parentNode.removeChild(this._container);
            }
        }
    },

  onAdd: function (map) {
    
  },

  onRemove: function () {
    
  },

  enableEdit: function () {
    this._container.removeChild(this._textBlock);
    $(this._textBlock).resizable("enable");
    this._container.appendChild(this._textBlock);
    this._container.className += ' editing';
    this._draggable.enable();
  },

  disableEdit: function () {
    this._container.removeChild(this._textBlock);
    $(this._textBlock).resizable("disable");
    this._container.appendChild(this._textBlock);
    this._container.className.replace(' editing', '');
    this._draggable.disable();
  },

  setZIndex: function (zIndex) {
    this._container.style.zIndex = zIndex;
  },

  _initInteraction: function () {
    this._draggable = new L.Draggable(this._container);

    this._draggable.on({
      dragend: this._onDragEnd
    }, this);

    var self = this;

    if ($(this._textBlock).resizable) {
      $(this._textBlock).resizable({
        disabled: true,
        stop: function (e) {
          self._onTextBlockResized(e, self);
          self._draggable.enable();
        }
      });
    }

    $('.ui-resizable-handle', this._textBlock).on('mousedown', function () {
      self._draggable.disable();
    });
  },

  _onDragEnd: function (e) {
    var center = this._getMapCenter();

    var newPosition = {
      x: e.target._newPos.x - center.x,
      y: e.target._newPos.y - center.y
    };

    this._setPosition(newPosition);
    this.options.position = newPosition;
    this._mainMap.fire('textBlockMoved', newPosition);
  },

  _getMapCenter: function () {
    var size = this._mainMap.getSize();

    var centerX = Math.round(size.x / 2);
    var centerY = Math.round(size.y / 2);

    return {
      x: centerX,
      y: centerY
    };
  },

  _setPosition: function (pos) {
    var center = this._getMapCenter();

    var positionInMap = {
      x: center.x + pos.x,
      y: center.y + pos.y
    };

    L.DomUtil.setPosition(this._container, new L.Point(positionInMap.x, positionInMap.y));
  },

  _getViewportXY: function () {
    var size = this._mainMap.getSize();

    var viewportX = Math.round((size.x - this.options.viewport.width) / 2);
    var viewportY = Math.round((size.y - this.options.viewport.height) / 2);

    return {
      x: viewportX,
      y: viewportY
    };
  },

  _onTextBlockResized: function (e, self) {
    var equalWidth = self._textBlock.offsetWidth === self._textBlock.originalW;
    var equalHeight = self._textBlock.offsetHeight === self._textBlock.originalH;
    if (!equalWidth && !equalHeight) {
      self._mainMap.fire('textBlockResized', { width: e.target.offsetWidth, height: e.target.offsetHeight });
      self._textBlock.originalW = self._textBlock.offsetWidth;
      self._textBlock.originalH = self._textBlock.offsetHeight;
    }
  },

  _onMainMapResize: function () {
    this._setPosition(this.options.position);
  }
});

L.textBlock = function (options) {
  return new L.TextBlock(options);
};
define("leaflet-text-block", function(){});

